import { defineComponent, PropType } from 'vue'
import { CsAccordion, MsHeadline, CsCheckbox } from '@sunrise/components'
import { Value } from '../filter.types'

export default defineComponent({
    name: 'CsNewsCategory',
    components: { CsCheckbox, MsHeadline, CsAccordion },
    model: {
        prop: 'modelValue',
        event: 'update:modelValue',
    },
    props: {
        selectedCategories: {
            type: Array as PropType<string[]>,
            required: true,
        },
        filterValues: { type: Object as PropType<Value[]>, required: true },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        function onUpdateCategory(updatedCategories: any) {
            emit('update:modelValue', updatedCategories)
        }

        return {
            onUpdateCategory,
        }
    },
})
